import { Handle, Position } from '@xyflow/react';

const MACROCATEGORIA_LABELS = {
  100000000: 'Manutenzione',
  100000001: 'Servizi',
  100000002: 'Forniture',
  100000003: 'Consulenza'
};

const STATO_LABELS = {
  100000000: 'Attivo',
  100000001: 'Inattivo',
  100000002: 'Sospeso'
};

function FornitoreNode({ data, selected }) {
  return (
    <div
      className={`px-4 py-3 rounded-lg border-2 shadow-md min-w-[180px] transition-all ${
        selected
          ? 'border-green-600 bg-green-100 ring-2 ring-green-300'
          : 'border-green-400 bg-green-50 hover:border-green-500 hover:shadow-lg'
      }`}
    >
      <Handle type="target" position={Position.Left} className="!bg-green-500" />

      <div className="flex items-center gap-2 mb-1">
        <span className="text-lg">🏢</span>
        <span className="text-xs font-semibold text-green-600 uppercase tracking-wide">Fornitore</span>
      </div>

      <div className="font-semibold text-gray-800 text-sm leading-tight">
        {data.nome}
      </div>

      {data.macrocategoria !== undefined && (
        <div className="text-xs text-gray-500 mt-1">
          {MACROCATEGORIA_LABELS[data.macrocategoria] || 'N/D'}
        </div>
      )}

      {data.stato !== undefined && (
        <div className="mt-2">
          <span className={`inline-block text-xs px-2 py-0.5 rounded-full ${
            data.stato === 100000000
              ? 'bg-green-100 text-green-700'
              : data.stato === 100000002
              ? 'bg-yellow-100 text-yellow-700'
              : 'bg-gray-100 text-gray-600'
          }`}>
            {STATO_LABELS[data.stato] || 'N/D'}
          </span>
        </div>
      )}

      <Handle type="source" position={Position.Right} className="!bg-green-500" />
    </div>
  );
}

export default FornitoreNode;
